import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { SidebarModule } from 'primeng/sidebar';
import { ButtonComponent } from '../button/button.component';
import { MessageComponent } from '../message/message.component';

@Component({
  selector: 'app-panel',
  standalone: true,
  imports: [CommonModule, SidebarModule, ButtonComponent, MessageComponent],
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss'],
})
export class PanelComponent {
  @Input() position: 'left' | 'right' = 'right';
  @Input() visible: boolean;
  @Input() closeIcon: boolean;
  @Input() template: TemplateRef<any> | null = null;
  @Input() header: string;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() eventBackground: EventEmitter<boolean> = new EventEmitter<boolean>();

  change(value: boolean) {
    this.visibleChange.emit(value);
  }

  clickBackground(value: boolean) {
    this.eventBackground.emit(value);
  }
}
